import { useContext } from 'react';
import { observer } from "mobx-react-lite";
import Menu from 'components/Menu'
import ApplicationContext from 'contexts/application-context';
import Chat, { ChatState } from 'components/ChatSystem';
import { UserInfo } from 'components/User';
import {
  Main,
  Content
} from './Styles'
import { IPublicStruct } from 'interfaces/IPublicStruct';
import Tip from 'components/Tip';


interface props {
  children: React.ReactElement;
}

function ApplicationLayout({ children }: props) {

  const ApplicationCtx = useContext(ApplicationContext)

  return (
    <Main>
      <Menu game={ApplicationCtx.game} />
      <Content className={ChatState.isOpen ? 'chatOpen' : ''}>
        {children}
        <Chat />
        {/* <UserInfo data={UserData} /> */}
      </Content>
    </Main>
  )
}

export default observer(ApplicationLayout)